import formatDate from '../../../../../../../core/utils/formatDate';

const EVENT_TYPES = {
  addParticipant: 'added',
  updateParticipant: 'updated',
  deleteParticipant: 'removed',
};

const adminPropertyStartDate = new Date('2020-11-25').toISOString();

export const formatHistoryEvents = (events) =>
  events.reduce((eventsData, event) => {
    const allEvents = eventsData;
    const getEventUser = (param) => {
      const { user, admin, createdAt } = event;
      const validUser = Object.keys(user).length > 0;

      // Due to https://github.com/aulaeducation/aula/issues/9834 we were not
      // recording the Aula admin who was making participant changes via the
      // Admin Dashboard. 2020-11-25 was the day the fix was deployed.
      // If we did not check for this date, we would label Admin Dashboard
      // imports as Import API operations which could cause confusion for users.
      const fromAdminDashboard =
        admin || (!validUser && createdAt < adminPropertyStartDate);
      const fromImportAPI = !validUser && !fromAdminDashboard;

      if (fromAdminDashboard) {
        return 'Admin import';
      }
      if (fromImportAPI) {
        return 'University Registry';
      }
      return param === 'id' ? user.id : `${user.firstName} ${user.lastName}`;
    };
    const formatOptions = { includeTime: false };
    const eventDate = formatDate(event.createdAt, formatOptions);
    const eventData = {
      ...event,
      eventType: EVENT_TYPES[event.eventType],
      createdAt: eventDate,
      key: `${event.participant.id}-${event.createdAt}`,
    };
    const eventKey = `${getEventUser('id')}-${eventData.eventType}`;
    const historyEventObject = {
      user: getEventUser(),
      eventType: eventData.eventType,
      data: [eventData],
    };

    if (!allEvents[eventDate]) {
      allEvents[eventDate] = {
        [eventKey]: historyEventObject,
      };
      return allEvents;
    }
    if (!allEvents[eventDate][eventKey]) {
      allEvents[eventDate][eventKey] = historyEventObject;
      return allEvents;
    }
    allEvents[eventDate][eventKey].data.push(eventData);
    return allEvents;
  }, {});

export const isAddOrUpdate = (eventType) =>
  eventType === EVENT_TYPES.addParticipant ||
  eventType === EVENT_TYPES.updateParticipant;
